var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('footer',{staticClass:"footer"},[_vm._v("\n\t        © 2018 Ogéo Procurement Platform\n\t    ")])])}]

export { render, staticRenderFns }